import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronUp_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.7071 22.7071C28.3166 23.0976 27.6834 23.0976 27.2929 22.7071L16 11.4142L4.70711 22.7071C4.31658 23.0976 3.68342 23.0976 3.29289 22.7071C2.90237 22.3166 2.90237 21.6834 3.29289 21.2929L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289L28.7071 21.2929C29.0976 21.6834 29.0976 22.3166 28.7071 22.7071Z"
            />
        </SvgStyled>
    );
};

export default ChevronUp_lg;
